export const categories = [
  { id: 1, name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
  { id: 2, name: '电影大片', slug: 'movie', icon: 'ri-film-line' },
  { id: 3, name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { id: 4, name: '动漫番剧', slug: 'anime', icon: 'ri-emotion-line' },
  { id: 5, name: '综艺娱乐', slug: 'variety', icon: 'ri-mic-line' },
  { id: 6, name: '纪录片', slug: 'documentary', icon: 'ri-global-line' },
  { id: 7, name: '短剧爽片', slug: 'short', icon: 'ri-flashlight-line' },
  { id: 8, name: '少儿频道', slug: 'kids', icon: 'ri-bear-smile-line' },
];

export const videos = [
  {
    id: 1,
    title: '流浪地球3：星际远征',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20astronauts%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20blue%20and%20orange%20color%20scheme%2C%20epic%20scale%2C%20film%20poster%20style&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    rating: 9.2,
    duration: '2h 28min',
    year: 2025,
    description: '国产科幻巨制续作，人类面临全新星际危机，团结一致探索未知宇宙的壮丽征程。',
    tags: ['科幻', '冒险', '国产'],
    views: '1280万',
  },
  {
    id: 2,
    title: '繁花似锦',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20featuring%20elegant%20traditional%20Chinese%20costumes%2C%20warm%20golden%20lighting%2C%20nostalgic%20Shanghai%20background%2C%20dramatic%20composition%2C%20vintage%20film%20aesthetic&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    rating: 8.8,
    duration: '40集',
    year: 2025,
    description: '讲述上世纪九十年代上海滩的商海沉浮与人生百态，群星荟萃的年代传奇大剧。',
    tags: ['年代', '商战', '剧情'],
    views: '2560万',
  },
  {
    id: 3,
    title: '封神第二部：战火西岐',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20dramatic%20cinematic%20lighting%2C%20gold%20and%20crimson%20color%20palette&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    rating: 8.5,
    duration: '2h 35min',
    year: 2025,
    description: '神话史诗巨制，姜子牙率领西岐大军迎战商朝，神魔大战一触即发。',
    tags: ['神话', '史诗', '奇幻'],
    views: '1890万',
  },
  {
    id: 4,
    title: '斗罗大陆之绝世唐门',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20poster%20with%20martial%20arts%20characters%20in%20fantasy%20world%2C%20vibrant%20colors%2C%20dynamic%20action%20pose%2C%20magical%20effects%2C%20illustration%20art%20style&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    rating: 9.5,
    duration: '更新至156集',
    year: 2025,
    description: '顶级国产3D动漫，少年霍雨浩在斗罗大陆上书写属于自己的传奇故事。',
    tags: ['玄幻', '热血', '3D'],
    views: '5200万',
  },
  {
    id: 5,
    title: '奔跑吧第十季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20vibrant%20colors%2C%20energetic%20atmosphere%2C%20entertainment%20program%20style%2C%20outdoor%20setting&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    rating: 8.0,
    duration: '更新至8期',
    year: 2025,
    description: '王牌综艺全新一季回归，明星嘉宾爆笑挑战，欢乐不间断。',
    tags: ['户外', '真人秀', '搞笑'],
    views: '3800万',
  },
  {
    id: 6,
    title: '舌尖上的中国第五季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20showing%20delicious%20traditional%20Chinese%20cuisine%20dishes%2C%20warm%20steaming%20food%2C%20artistic%20food%20photography%2C%20rich%20colors%2C%20cultural%20atmosphere&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    rating: 9.7,
    duration: '8集全',
    year: 2025,
    description: '经典美食纪录片全新一季，探寻中国各地最地道的人间美味与饮食文化。',
    tags: ['美食', '文化', '人文'],
    views: '4500万',
  },
  {
    id: 7,
    title: '霸道总裁的契约新娘',
    category: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20short%20drama%20poster%20featuring%20romantic%20couple%20in%20modern%20luxury%20setting%2C%20dramatic%20lighting%2C%20fashionable%20outfits%2C%20romantic%20atmosphere%2C%20vertical%20video%20aesthetic&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    rating: 7.8,
    duration: '80集全',
    year: 2025,
    description: '超人气短剧，契约婚姻假戏真做，甜宠虐恋一应俱全，根本停不下来。',
    tags: ['甜宠', '短剧', '爱情'],
    views: '9200万',
  },
  {
    id: 8,
    title: '超级飞侠大电影',
    category: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20children%20animated%20movie%20poster%20with%20cute%20airplanes%20and%20colorful%20characters%2C%20bright%20happy%20colors%2C%20playful%20design%2C%20kids%20entertainment%20style%2C%20adventure%20theme&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    rating: 8.6,
    duration: '1h 32min',
    year: 2025,
    description: '孩子们最爱的超级飞侠登上大银幕，全新冒险之旅欢乐启航。',
    tags: ['动画', '冒险', '亲子'],
    views: '1600万',
  },
  {
    id: 9,
    title: '狂飙：暗流涌动',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20intense%20atmosphere%2C%20police%20and%20criminal%20confrontation%2C%20dark%20noir%20lighting%2C%20suspenseful%20mood%2C%20film%20noir%20style&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    rating: 9.1,
    duration: '36集全',
    year: 2025,
    description: '扫黑除恶题材力作续篇，正邪较量再度升级，演技派群星飙戏。',
    tags: ['悬疑', '犯罪', '剧情'],
    views: '6700万',
  },
  {
    id: 10,
    title: '凡人修仙传动漫',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20immortal%20cultivator%20in%20ancient%20Chinese%20landscape%2C%20ethereal%20misty%20mountains%2C%20magical%20energy%20effects%2C%20ink%20painting%20style%20influence&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    rating: 9.3,
    duration: '更新至89集',
    year: 2025,
    description: '国漫修仙神作，凡人韩立步步为营，在残酷修真界中逆天改命。',
    tags: ['修仙', '热血', '3D'],
    views: '4100万',
  },
  {
    id: 11,
    title: '极限挑战宝藏行',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20challenge%20variety%20show%20poster%20with%20celebrities%20doing%20fun%20tasks%2C%20bright%20natural%20scenery%2C%20playful%20expressions%2C%20energetic%20composition&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    rating: 8.3,
    duration: '更新至12期',
    year: 2025,
    description: '极限男人帮再度集结，走遍祖国大好河山，挑战不可能的任务。',
    tags: ['户外', '挑战', '搞笑'],
    views: '2900万',
  },
  {
    id: 12,
    title: '地球脉动：亚洲篇',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20showing%20stunning%20Asian%20wildlife%20and%20landscapes%2C%20snow%20leopards%20in%20mountains%2C%20tropical%20rainforest%2C%20breathtaking%20aerial%20photography%2C%20BBC%20style&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    rating: 9.8,
    duration: '6集全',
    year: 2025,
    description: 'BBC级别自然纪录片，聚焦亚洲大陆的神奇动物与壮丽景观。',
    tags: ['自然', '动物', '科普'],
    views: '3200万',
  },
];

export const articles = [
  {
    id: 1,
    title: '2025年最值得期待的十部国产电影，每一部都是王炸',
    excerpt: '从科幻巨制到现实主义力作，今年国产电影市场百花齐放，这十部电影绝对不容错过。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20theater%20interior%20with%20film%20posters%20on%20display%2C%20cinematic%20atmosphere%2C%20warm%20red%20and%20gold%20lighting%2C%20elegant%20movie%20poster%20display&width=800&height=450&seq=article-thumb-01&orientation=landscape',
    category: '影视资讯',
    author: '白云影视观察',
    date: '2025-07-28',
    readTime: '8分钟',
    views: '12.6万',
    content: `2025年已经过半，国产电影市场交出了一份令人惊喜的答卷。从春节档的票房井喷，到暑期档的百花齐放，中国电影正在以肉眼可见的速度成长。

## 科幻新纪元

《流浪地球3：星际远征》无疑是今年最受瞩目的国产科幻大片。作为流浪地球系列的第三部，影片在视觉特效和故事深度上都达到了新的高度。导演郭帆在接受采访时表示，这一部将探索更宏大的宇宙主题，同时也将更加聚焦人物的情感内核。

## 神话史诗的重塑

《封神第二部：战火西岐》延续了第一部的史诗质感。乌尔善导演用他独特的视觉语言，将中国古代神话搬上大银幕，呈现出前所未有的震撼效果。影片中的神魔大战场面，被誉为国产电影特效的新标杆。

## 现实主义力作

除了商业大片，今年的现实主义题材同样令人期待。多部聚焦当下社会议题的影片将在下半年陆续上映，这些作品用真诚的视角讲述普通人的故事，引发观众的深度共鸣。

## 动画电影的崛起

国产动画电影也在持续发力。从《哪吒》到《长安三万里》，再到今年的多部动画新作，中国动画人正在用实力证明，国产动画已经具备了世界级的制作水准。

无论如何，2025年的国产电影市场都值得每一个影迷期待。走进电影院，支持中国电影，让我们一起见证这个黄金时代的到来。`,
  },
  {
    id: 2,
    title: '从"霸总短剧"到"精品微短剧"，行业正在经历怎样的变革？',
    excerpt: '短剧行业从野蛮生长到精品化转型，市场规模突破500亿，这条赛道正在重塑内容产业的格局。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20vertical%20video%20content%2C%20film%20production%20set%20background%2C%20professional%20lighting%20equipment%2C%20creative%20media%20industry%2C%20warm%20cinematic%20lighting&width=800&height=450&seq=article-thumb-02&orientation=landscape',
    category: '行业观察',
    author: '白云编辑部',
    date: '2025-07-25',
    readTime: '6分钟',
    views: '8.3万',
    content: `2023年被称作"短剧元年"，两年过去，这个行业已经从野蛮生长进入了精品化竞争的新阶段。

## 从量变到质变

早期短剧以"霸总""逆袭""甜宠"等题材为主，制作周期短、成本低，但内容同质化严重。随着市场逐渐成熟，观众对内容质量的要求也在提高。越来越多的制作方开始投入更大预算，力求在有限的时长内呈现更高质量的内容。

## 市场规模

据行业报告显示，2025年中国短剧市场规模已突破500亿元，用户规模超过6亿。这个曾经被视为"low"的内容形式，正在成为各大平台争相布局的重要赛道。

## 精品化趋势

头部平台纷纷推出"精品微短剧"计划，邀请知名导演、编剧参与创作。题材也从单一的情感类拓展到悬疑、科幻、历史等多个领域。制作水准的提升，让短剧逐渐摆脱了"粗制滥造"的标签。

## 出海热潮

中国短剧不仅在国内火爆，在海外市场同样表现亮眼。多部短剧在东南亚、北美等地区取得了惊人的播放量，成为文化出海的新名片。

短剧行业正在经历一场深刻的变革。未来的短剧，将是精品内容与高效传播的完美结合。`,
  },
  {
    id: 3,
    title: '国漫崛起：从模仿到超越，中国动画的二十年蜕变之路',
    excerpt: '从《大闹天宫》到《哪吒之魔童降世》，再到如今的国漫百花齐放，中国动画走过了怎样的道路？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artist%20working%20on%20digital%20tablet%2C%20colorful%20character%20designs%20on%20screen%2C%20creative%20workspace%2C%20modern%20animation%20production%2C%20vibrant%20artistic%20atmosphere&width=800&height=450&seq=article-thumb-03&orientation=landscape',
    category: '动漫文化',
    author: '白云动漫迷',
    date: '2025-07-20',
    readTime: '10分钟',
    views: '15.1万',
    content: `中国动画的发展史，是一部从模仿到创新、从跟随到引领的蜕变史。

## 早期的辉煌与低谷

上世纪六十年代，上海美术电影制片厂的《大闹天宫》震惊世界，中国动画学派独树一帜。然而此后的数十年间，受限于技术和市场环境，中国动画进入了漫长的低谷期。

## 市场化转型

进入21世纪，随着市场经济的深入发展，中国动画开始走上产业化道路。《喜羊羊与灰太狼》《熊出没》等系列作品培养了一代观众的动画消费习惯。

## 互联网时代的爆发

2015年，《大圣归来》以9.56亿票房宣告国漫归来。此后《哪吒之魔童降世》更是以50亿票房创造了中国动画电影的新纪录。国漫不再是低幼的代名词，全年龄向的精品内容不断涌现。

## 3D动画的技术突破

以《斗罗大陆》《凡人修仙传》为代表的3D国漫，在技术上已经达到国际一流水准。流畅的动作设计、精美的场景渲染，让观众看到了中国动画的硬实力。

如今的国漫，不仅有情怀，更有品质。中国动画人正在用自己的努力，书写属于这个时代的传奇。`,
  },
  {
    id: 4,
    title: '手机看片体验大对比：哪款App才是你的追剧神器？',
    excerpt: '白云视频深度评测当前主流视频App的播放体验，从画质、流畅度、内容库等维度一探究竟。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Multiple%20smartphones%20displaying%20video%20streaming%20apps%20on%20screens%2C%20modern%20minimal%20setup%2C%20warm%20ambient%20lighting%2C%20tech%20review%20style%2C%20clean%20composition&width=800&height=450&seq=article-thumb-04&orientation=landscape',
    category: '使用评测',
    author: '白云体验官',
    date: '2025-07-15',
    readTime: '7分钟',
    views: '22.8万',
    content: `在手机看片已经成为日常的今天，选择一款好用的视频App至关重要。我们深度体验了市面上多款主流视频App，从多个维度进行了全面对比。

## 画质表现

在4K画质测试中，白云视频的表现令人惊喜。即便在网络条件一般的情况下，自适应码率技术也能保证流畅清晰的观看体验。相比之下，部分竞品在高画质模式下会出现明显的缓冲等待。

## 流畅度

流畅度是手机看片体验的核心。我们使用同一网络环境进行了对比测试，白云视频的启播速度和拖拽响应都名列前茅。这得益于其先进的视频传输和缓存技术。

## 内容丰富度

从热门大片到经典老片，从国产剧到海外剧，白云视频的内容库覆盖面广泛。特别是在国产影视内容方面，更新速度和质量都处于行业领先水平。

## 界面体验

清爽无广告的界面设计，让白云视频在用户体验上获得了很高的评价。智能推荐算法也能根据用户的观看习惯，精准推送感兴趣的内容。

综合来看，白云视频在各项评比中都表现出色，是2025年最值得推荐的手机看片App之一。`,
  },
  {
    id: 5,
    title: '暑期档必追！这些新剧让你整个夏天不再剧荒',
    excerpt: '炎炎夏日，宅家追剧是最佳选择。我们为你精选了暑期档最值得期待的十部新剧。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20home%20living%20room%20with%20large%20TV%20screen%20showing%20colorful%20drama%20scene%2C%20comfortable%20sofa%2C%20summer%20afternoon%20atmosphere%2C%20warm%20natural%20light%2C%20relaxing%20vibe&width=800&height=450&seq=article-thumb-05&orientation=landscape',
    category: '影视资讯',
    author: '白云追剧指南',
    date: '2025-07-10',
    readTime: '5分钟',
    views: '18.5万',
    content: `暑期档是各大平台集中发力的时候，今年的新剧阵容格外强大。我们为大家精选了十部最值得期待的暑期新剧，保证让你的夏天追剧不重样。

## 悬疑烧脑

今年的悬疑剧质量整体很高。多部改编自知名推理小说的剧集将陆续上线，烧脑程度直接拉满。喜欢动脑筋的观众千万不要错过。

## 甜宠治愈

夏天当然少不了甜甜的恋爱剧。今年的甜宠剧在剧情设计上更加用心，不再是简单的甜，而是甜中带虐、笑中带泪，让人欲罢不能。

## 古装巨制

多部投资过亿的古装大剧也将在暑期档亮相。精美的服化道、宏大的场景调度，每一帧都是壁纸级别的视觉享受。

## 现实题材

反映当代社会生活的现实题材剧集同样值得关注。这些作品贴近生活、引发共鸣，是暑期档的一股清流。

准备好零食和饮料，这个暑假，白云视频陪你一起追剧！`,
  },
  {
    id: 6,
    title: '一文读懂视频平台推荐算法：为什么总能看到你想看的内容？',
    excerpt: '视频平台的推荐系统是如何工作的？它为什么总能精准猜中你的喜好？让我们揭开推荐算法的神秘面纱。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20representing%20algorithm%20and%20technology%2C%20flowing%20lines%20and%20nodes%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20modern%20tech%20design%2C%20clean%20minimal%20style&width=800&height=450&seq=article-thumb-06&orientation=landscape',
    category: '技术揭秘',
    author: '白云技术团队',
    date: '2025-07-05',
    readTime: '9分钟',
    views: '6.7万',
    content: `每次打开视频App，首页推荐的内容总是让你忍不住点进去。这背后是一套复杂的推荐算法在默默工作。

## 协同过滤

这是最经典的推荐算法之一。简单来说，就是"找和你相似的人，推荐他们喜欢的内容"。系统通过分析海量用户的观看行为，找到与你有相似口味的用户群体，然后把他们喜欢的内容推荐给你。

## 内容理解

算法不仅看人，也看内容本身。通过AI技术，系统能够理解视频的类型、主题、风格、情感倾向等信息。当你频繁观看某一类内容时，系统会自动为你推荐相似的内容。

## 实时反馈

推荐系统会实时收集你的每一个行为——观看时长、点赞、收藏、分享等，并据此不断调整推荐策略。你停留越久的内容类型，系统就越倾向于推荐类似的。

## 冷启动与探索

对于新用户，系统会采用冷启动策略，先推荐热门和多样化的内容，然后根据反馈逐步优化。同时，系统也会保留一定的"探索"空间，偶尔推荐一些你平时不常看的内容类型，帮你发现新的兴趣。

理解推荐算法的原理，不仅能帮你更好地使用视频平台，也能让你对这个精心设计的内容世界有更深的认识。`,
  },
];

export const reviews = [
  { id: 1, name: '追剧达人小王', rating: 5, comment: '用了白云视频之后，其他App都卸载了。画质高清，缓冲快，关键是免费！强烈推荐给所有爱追剧的朋友。', date: '2025-07-30' },
  { id: 2, name: '电影发烧友', rating: 5, comment: '资源真的太全了，很多在别的地方找不到的老片这里都有。画质清晰度也很高，用大屏看体验超棒。', date: '2025-07-28' },
  { id: 3, name: '动漫迷小李', rating: 5, comment: '国漫资源更新速度全网第一！斗罗大陆、凡人修仙传都是第一时间更新，追番神器！', date: '2025-07-25' },
  { id: 4, name: '宝妈追剧人', rating: 4, comment: '界面简洁没有乱七八糟的广告，给孩子放动画片也放心。少儿频道的资源很丰富，孩子很喜欢。', date: '2025-07-22' },
  { id: 5, name: '上班族小陈', rating: 5, comment: '通勤路上必备App！短剧专区太适合碎片时间了，一集几分钟，等地铁的时间就能看完。', date: '2025-07-20' },
  { id: 6, name: '学生党阿杰', rating: 5, comment: '免费又高清，对没有收入的学生党太友好了。宿舍晚上一起追剧，氛围感拉满！', date: '2025-07-18' },
];

export const stats = [
  { label: '日活用户', value: '5000万+' },
  { label: '影视资源', value: '10万+' },
  { label: '好评率', value: '98.6%' },
  { label: '覆盖地区', value: '全球200+' },
];

export const faqs = [
  { question: '白云视频是免费的吗？', answer: '是的，白云视频是一款完全免费的手机在线视频播放平台。所有影视内容均可免费观看，无需付费订阅。我们致力于为每一位用户提供优质、免费的视频观看体验。' },
  { question: '白云视频支持哪些设备？', answer: '白云视频目前支持iOS和Android手机设备，同时也支持平板电脑。您可以通过手机浏览器直接访问，也可以下载我们的App获得更好的观看体验。' },
  { question: '视频播放卡顿怎么办？', answer: '白云视频采用先进的视频传输和自适应码率技术，会自动根据您的网络状况调整画质。如果遇到卡顿，建议您切换到较低清晰度，或检查网络连接后重试。' },
  { question: '如何搜索我想看的视频？', answer: '在首页顶部的搜索框中输入影片名称或关键词，系统会智能匹配相关结果。您也可以通过分类导航浏览不同类别的影视内容。' },
  { question: '白云视频有广告吗？', answer: '白云视频致力于提供纯净的观看体验，播放过程中不插入任何贴片广告或弹窗广告，让您畅享无干扰的追剧时光。' },
  { question: '视频资源多久更新一次？', answer: '我们的内容团队每日更新资源，热门剧集和综艺节目会在播出后第一时间上线，确保您不会错过任何精彩内容。' },
];

export const contacts = [
  { type: '邮箱', value: 'contact@baiyunvideo.com', icon: 'ri-mail-line' },
  { type: '客服微信', value: 'baiyunvideo_kf', icon: 'ri-wechat-line' },
  { type: '官方微博', value: '@白云视频官方', icon: 'ri-weibo-line' },
  { type: '商务合作', value: 'business@baiyunvideo.com', icon: 'ri-briefcase-line' },
];

export const categoryDisplayNames: Record<string, string> = {
  hot: '热门推荐',
  movie: '电影大片',
  tv: '电视剧',
  anime: '动漫番剧',
  variety: '综艺娱乐',
  documentary: '纪录片',
  short: '短剧爽片',
  kids: '少儿频道',
};